export function formatCentsAsUsd(cents: number | null, fallback = "—"): string {
  if (cents == null) return fallback

  const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const decimalDollars = parseFloat((cents / 100).toFixed(2))
  return usdFormatter.format(decimalDollars)
}

export function parseDollarsToCents(dollarsAndCentsString: string): number | undefined {
  const cleanedInputString = dollarsAndCentsString.replace(/[$,]/g, "")
  const parsedDollarsFloat = parseFloat(cleanedInputString)

  if (!Number.isNaN(parsedDollarsFloat)) {
    return Math.round(100 * parsedDollarsFloat)
  } else {
    return undefined
  }
}
